import { useEffect, useRef } from "react";
import styled from "styled-components";
import gsap from "gsap";
import BackButton from "@common/ui/BackButton";
import { useStore } from "@state/store";
import { useProjectDataStore } from "@state/projectDataStore";
import FloorplanSection from "./FloorplanSection";
import ViewSection from "../ViewSection";
import TextButton from "@common/ui/TextButton";
import { HeartFilledIcon, HeartIcon } from "@radix-ui/react-icons";
import { useFavoritesStore } from "@state/favouritesStore";
import SpecsSection from "../SpecsSection";
import Popup from "../Popup";

const ResidencePopup = ({ selectedUnit }) => {
  const wrapperRef = useRef();
  const { addToFavorites, isFavorite } = useFavoritesStore();
  const syncState = useStore((s) => s.syncState);
  const residencePopup = useStore((s) => s.residencePopup);
  const { brandingData } = useProjectDataStore((s) => ({
    brandingData: s.brandingData,
  }));
  const imageOverlay = useStore((s) => s.imageOverlay);
  let viewID;
  if (selectedUnit) viewID = selectedUnit[0]?.viewID;
  return (
    <Popup
      openState={residencePopup}
      setOpenState={(x) => {
        syncState({
          residencePopup: x,
        });
      }}
      withClose={false}
      durationMS={400}
      style={{
        width: "85%",
        display: "flex",
      }}
    >
      <Spacer>
        <img src="assets/imgs/Story/21.webp" alt="" />
      </Spacer>
      <Wrapper
        className="residences-popup"
        ref={wrapperRef}
        bgImage={brandingData?.bgImage?.publicURL}
      >
        <FloorplanSection selectedUnit={selectedUnit} />
        {/* <ViewSection viewID={viewID} /> */}
      </Wrapper>
    </Popup>
  );
};

export default ResidencePopup;

const Wrapper = styled.div<{ bgImage }>`
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  background-color: #e4ddd4;
  background-size: cover;
  border-left: 1px solid var(--accent);
  z-index: 10;
`;

const Spacer = styled.div`
  position: relative;
  height: 100%;
  width: 33.5%;
  background-color: var(--black);

  & img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0.4;
  }
`;
